import styled from "styled-components";

export const TileDetailsContainer = styled.div`
.tile-img-wrapper{
    max-height:500px;
}
.img-container{
 height:350px;
 width:100%;
 position:relative;
}
.fs-14{
    font-size:14px;
}
.fs-20{
    font-size:20px;
}
.fs-24{
    font-size:24px;
}
.merch-grid{
    display:grid;
    grid-template-columns:repeat(2,1fr);
    gap:5px;
    justify-content:center;
    align-items:center;
    .merge-container{
        height:280px;
        width:100%;
        box-shadow: 0 16px 64px -16px rgb(46 55 77 / 10%);
        cursor:pointer;
    :hover{
        box-shadow: 0 16px 64px -16px rgb(46 55 77 / 24%);
    }
    }
    .merge-img-container{
        height:150px;
        width:100%;
        position:relative;
        
    }
   
}
@media(max-width:600px){
    
}
@media(min-width:768px){
    .merch-grid{
        display:grid;
        grid-template-columns:repeat(3,1fr);
        gap:10px;
        justify-content:center;
        align-items:center;
      
        .merge-img-container{
            height:150px;
            width:100%;
            position:relative;
        }
    }
}

@media(min-width:920px){
    .merch-grid{
        display:grid;
        grid-template-columns:repeat(4,1fr);
        gap:10px;
        justify-content:center;
        align-items:center;
        
        .merge-img-container{
            height:150px;
            width:100%;
            position:relative;
        }
    }
}


@media(min-width:1280px){
    .merch-grid{
        display:grid;
        grid-template-columns:repeat(4,1fr);
        gap:10px;
        justify-content:center;
        align-items:center;
        .merge-img-container{
            height:160px;
            width:100%;
            position:relative;
        }
    }
}

`;

